class Dropdown extends HTMLElement {
  constructor() {
    super()

    this.header = this.querySelector('.dropdown-header')
    this.copy = this.querySelector('.dropdown-copy')
    this.initialiseDropdown()
  }

  initialiseDropdown() {

    this.header.addEventListener('click', () => {

      this.copy.classList.toggle('active')
      this.copy.style.maxHeight = `${this.copy.scrollHeight + 20}px`
      this.header.classList.toggle('active')

      const classes = this.copy.classList
      if (!classes.contains('active')) {
        this.copy.style.maxHeight = `0px`
      }


    })

  }


}

customElements.define('dropdown-accordion', Dropdown)
